import { render, staticRenderFns } from "./FortePayment.vue?vue&type=template&id=80c02724&"
import script from "./FortePayment.vue?vue&type=script&lang=js&"
export * from "./FortePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports